export default {"src":"/_next/static/media/tel_icon_active.eb28bebb.svg","height":49,"width":49,"blurWidth":0,"blurHeight":0};